import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, type EnrolledCourse } from '../api.ts';
import { Progress } from '../components/Progress.tsx';

/**
 * Everything the learner has been given, and nothing else.
 *
 * There is no catalogue to browse: a course appears here because a teacher enrolled this person
 * into it. An empty list is therefore not an error state but a perfectly normal "wait for your
 * teacher", and it says so.
 */
export function CoursesPage(): React.JSX.Element {
  const [courses, setCourses] = useState<EnrolledCourse[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .myCourses()
      .then(setCourses)
      .catch((cause: unknown) =>
        setError(cause instanceof Error ? cause.message : 'Не удалось загрузить курсы'),
      );
  }, []);

  return (
    <>
      <div className="page-head row" style={{ justifyContent: 'space-between' }}>
        <h1 style={{ margin: 0 }}>Мои курсы</h1>
        <div className="row">
          <Link to="/messages" className="btn btn--ghost btn--small">
            Вопрос преподавателю
          </Link>
          <Link to="/certificates" className="btn btn--ghost btn--small">
            Мои сертификаты
          </Link>
        </div>
      </div>

      {error ? <p className="error">{error}</p> : null}
      {courses === null && !error ? <p className="muted">Загружаем…</p> : null}

      {courses?.length === 0 ? (
        <div className="notice">Здесь появятся курсы, которые вам выдаст преподаватель.</div>
      ) : null}

      <div className="grid">
        {(courses ?? []).map((course) => (
          <Link key={course.course_id} to={`/courses/${course.course_id}`} className="course-card">
            <div className="course-card__title">{course.title}</div>
            {course.summary ? <p className="course-card__summary">{course.summary}</p> : null}
            <Progress percent={course.progress_percent} />
          </Link>
        ))}
      </div>
    </>
  );
}
